import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-roboto lg:pl-72 pb-16" }
const _hoisted_2 = {
  key: 0,
  class: "px-4 sm:px-6 lg:px-8 mt-6 mx-8 border border-gray-900/5 rounded-md shadow-sm"
}
const _hoisted_3 = { class: "flex justify-between gap-x-4 mt-8" }
const _hoisted_4 = { class: "flex justify-start" }
const _hoisted_5 = {
  class: "relative",
  action: "#",
  method: "GET"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "search-field",
  class: "sr-only"
}, "Search", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 py-3 h-full absolute left-1",
  src: "/img/Icons/Magnifying_glass.svg",
  alt: "Search Icon"
}, null, -1)
const _hoisted_8 = { class: "-mx-4 mt-8 sm:-mx-0" }
const _hoisted_9 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-dark-blue sm:pl-0 flex items-center"
    }, " School Name "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3.5 text-left text-sm font-semibold text-dark-blue sm:table-cell"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, " Town ")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "hidden px-3 py-3.5 text-left text-sm font-semibold text-dark-blue lg:table-cell"
    }, "School Status"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "relative py-3.5 pl-3 pr-4 sm:pr-0"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Edit")
    ])
  ])
], -1)
const _hoisted_11 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_12 = { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0" }
const _hoisted_13 = { class: "hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell" }
const _hoisted_14 = { class: "hidden whitespace-nowrap px-3 py-4 text-sm lg:table-cell" }
const _hoisted_15 = { class: "whitespace-nowrap py-4 text-sm font-medium sm:pr-0" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "sr-only" }
const _hoisted_19 = {
  key: 0,
  class: "absolute right-0 top-full w-40 z-10 mt-2 bg-white border border-gray-300 rounded-md shadow-md"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "School Details", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "mt-6 mx-8"
}
const _hoisted_24 = { class: "flex justify-between mt-4" }
const _hoisted_25 = { class: "text-base text-dark-blue" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl text-dark-blue text-center font-bold" }, "Requestor's Information", -1)
const _hoisted_27 = { class: "grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3 w-full" }
const _hoisted_28 = { class: "bg-white shadow-md ring-1 ring-gray-900/5 rounded-xl md:col-span-3 mx-auto w-3/5" }
const _hoisted_29 = { class: "px-4 py-6 sm:p-8" }
const _hoisted_30 = { class: "grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 mx-auto" }
const _hoisted_31 = { class: "sm:col-span-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "First name", -1)
const _hoisted_33 = { class: "mt-2" }
const _hoisted_34 = { class: "sm:col-span-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Last Name", -1)
const _hoisted_36 = { class: "mt-2" }
const _hoisted_37 = { class: "sm:col-span-full" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Email", -1)
const _hoisted_39 = { class: "mt-2" }
const _hoisted_40 = { class: "sm:col-span-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Phone Number", -1)
const _hoisted_42 = { class: "mt-2" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "flex justify-center mt-16" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "text-base text-dark-blue invisible" }, [
  /*#__PURE__*/_createTextVNode("Status: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-purple" }, "Requested")
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl text-dark-blue text-center font-bold" }, "Requested School's Information", -1)
const _hoisted_47 = { class: "flex justify-end gap-x-4" }
const _hoisted_48 = { class: "grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3" }
const _hoisted_49 = { class: "bg-white shadow-md ring-1 ring-gray-900/5 rounded-xl md:col-span-3 mx-auto w-3/5" }
const _hoisted_50 = { class: "px-4 py-6 sm:p-8" }
const _hoisted_51 = { class: "grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 mx-auto" }
const _hoisted_52 = { class: "sm:col-span-3" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "School Name*", -1)
const _hoisted_54 = { class: "mt-2" }
const _hoisted_55 = { class: "sm:col-span-3" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "School EMIS Number*", -1)
const _hoisted_57 = { class: "mt-2" }
const _hoisted_58 = { class: "sm:col-span-full" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Street Address*", -1)
const _hoisted_60 = { class: "mt-2" }
const _hoisted_61 = { class: "sm:col-span-2" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Town*", -1)
const _hoisted_63 = { class: "mt-2" }
const _hoisted_64 = { class: "sm:col-span-2" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Postal Code*", -1)
const _hoisted_66 = { class: "mt-2" }
const _hoisted_67 = { class: "flex justify-center mt-16" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("p", { class: "text-base text-dark-blue invisible" }, [
  /*#__PURE__*/_createTextVNode("Status: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-purple" }, "Requested")
], -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl text-dark-blue text-center font-bold" }, "Contact At School", -1)
const _hoisted_70 = { class: "flex justify-end gap-x-4" }
const _hoisted_71 = { class: "grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3" }
const _hoisted_72 = { class: "bg-white shadow-md ring-1 ring-gray-900/5 rounded-xl md:col-span-3 mx-auto w-3/5" }
const _hoisted_73 = { class: "px-4 py-6 sm:p-8" }
const _hoisted_74 = { class: "grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 mx-auto" }
const _hoisted_75 = { class: "sm:col-span-3" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Contact Person*", -1)
const _hoisted_77 = { class: "mt-2" }
const _hoisted_78 = { class: "sm:col-span-3" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Phone Number*", -1)
const _hoisted_80 = { class: "mt-2" }
const _hoisted_81 = { class: "flex justify-center mt-16" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("p", { class: "text-base text-dark-blue invisible" }, [
  /*#__PURE__*/_createTextVNode("Status: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-purple" }, "Requested")
], -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl text-dark-blue text-center font-bold" }, "School Bank Details", -1)
const _hoisted_84 = { class: "flex justify-end gap-x-4" }
const _hoisted_85 = { class: "grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3" }
const _hoisted_86 = { class: "flex justify-center mt-16" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("p", { class: "text-base text-dark-blue invisible" }, [
  /*#__PURE__*/_createTextVNode("Status: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-purple" }, "Requested")
], -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl text-dark-blue text-center font-bold" }, "Our Notes", -1)
const _hoisted_89 = { class: "flex justify-end gap-x-4" }
const _hoisted_90 = { class: "grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3" }
const _hoisted_91 = { class: "bg-white shadow-md ring-1 ring-gray-900/5 rounded-xl md:col-span-3 mx-auto w-3/5" }
const _hoisted_92 = { class: "px-4 py-6 sm:p-8" }
const _hoisted_93 = { class: "grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 mx-auto" }
const _hoisted_94 = { class: "sm:col-span-full" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Extra Information", -1)
const _hoisted_96 = { class: "mt-2" }
const _hoisted_97 = { class: "flex justify-center gap-x-16 mt-10" }

import AdminSidebar from '@/components/Layouts/AdminSidebar.vue'
import Toast from '@/helpers/Toast'
import Button from '@/components/Atomic/AQuarks/Button.vue'
import NotFound from '@/components/Atomic/BAtoms/NotFound.vue'
import {computed, onBeforeUnmount, onMounted, PropType, ref, watch} from 'vue';
import {useSchoolStore} from '@/areas/schools/stores/schoolStore'
import {SchoolDto} from '@/areas/schools/dtos/schoolDto'
import {SchoolStateEnum} from '@/areas/schools/enums/schoolStateEnum'
import {SchoolTypeEnum} from '@/areas/schools/enums/schoolTypeEnum'
import {BankAccountTypeEnum} from '@/areas/schools/enums/bankAccountTypeEnum'
import {UserDto} from '@/areas/users/dtos/userDto'
import bus from '@/bus'
import {BankDetailDto} from "@/areas/schools/dtos/bankDetailDto";
import {AddressDto} from "@/areas/addresses/dtos/addressDto";
import {ProvincesEnum} from "@/areas/schools/enums/provincesEnum";
import {RequestorRoleEnum} from "@/areas/schools/enums/requestorRoleEnum";
import Dropdown from "@/components/Atomic/AQuarks/Dropdown.vue";
import BankDetailsForm from "@/areas/schools/containers/BankDetailsForm.vue";
import {getEntityStateColour, getStatusClass} from "@/components/Atomic/BAtoms/schools/SchoolStateHelpers"
import SchoolStateFilterButtons from "@/components/Atomic/BAtoms/schools/SchoolStateFilterButtons.vue";
import {SearchDto} from "@/areas/helpers/searchDto";
import PaginationV2 from "@/components/Atomic/AQuarks/PaginationV2.vue";
import CampaignApproveModal from "@/components/Atomic/BAtoms/campaigns/modals/CampaignApproveModal.vue";
import CampaignDeclineModal from "@/components/Atomic/BAtoms/campaigns/modals/CampaignDeclineModal.vue";
import {UserContactDto} from "@/areas/users/dtos/userContactDto";
import {ContactTypeEnum} from "@/areas/schools/enums/contactTypeEnum";


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageSchools',
  props: {
  schoolDetails: {
    type: Object as PropType<SchoolDto>,
    default: {
      guid: '',
      name: '',
      emis: '',
      contactPersonName: '',
      contactPersonDetails: '',
      schoolType: '',
      entityState: undefined,
      bankDetail: undefined,
      address: {
        street: '',
        suburb: '',
        city: '',
        province: '',
        postalCode: '',
      } as AddressDto,
      notes: ''
    }
  },
  schoolBankDetails: {
    type: Object as PropType<BankDetailDto>,
    default: {
      name: '',
      branchCode: '',
      accountNumber: '',
      bankAccountType: BankAccountTypeEnum.Cheque
    }
  },
  searchDto: {
    type: Object as PropType<SearchDto>,
    default: {
      pageSize: 7,
      pageNumber: 1,
    }
  },
},
  setup(__props) {

const schools = ref<SchoolDto[]>()
const schoolStore = useSchoolStore()
const states = ref<SchoolStateEnum[]>();
const userDto = ref<UserDto | null>(null);

const props = __props

const schoolDetails = ref(props.schoolDetails)
const schoolBankDetails = ref(props.schoolBankDetails)
const searchDto = ref(props.searchDto)
const requestorNumber = ref<string>("")

// Dropdown options
const provinceOptions = Object.values(ProvincesEnum)
const schoolTypeOptions = Object.values(SchoolTypeEnum)
const requestorTypeOptions = Object.values(RequestorRoleEnum)
const schoolStateOptions = ref<SchoolStateEnum[]>([SchoolStateEnum.Approved, SchoolStateEnum.Rejected, SchoolStateEnum.Requested])

const hasBankDetailsErrors = ref<boolean>(false)
const hasSchoolErrors = ref<boolean>(false)
const showFormErrors = ref<boolean>(false)
const isReadyForApproval = ref<boolean>(false)

let searchTerm = ref<string>('')
let currentFilter = ref<string>('')
let showApproveModal = ref<boolean>(false)
let showDeclineModal = ref<boolean>(false)
let showSchoolDetails = ref<boolean>(false)
let selectedSchool = ref<SchoolDto | null>(null)
let showSearchField = ref<boolean>(true)
let pageTitle = ref<string>('School Management')

let role = ref<string>('')

watch(searchTerm, (newValue) => {
  if (newValue.trim() !== ''){
    
  }
})

const fetchSchoolsByState = async (state: SchoolStateEnum): Promise<SchoolDto[]> => {
  const result = await schoolStore.fetchAllSchools([state], searchTerm.value)
  
  if (result.isSuccessful){
    return result.content as SchoolDto[]
  }
  //TODO: Add error handling
  return []
}

const fetchAllSchools = async (states: SchoolStateEnum[]) => {
  let allSchools: SchoolDto[] = []
  for (let state of states) {
    const schoolsInState = await fetchSchoolsByState(state)
    allSchools = [...allSchools, ...schoolsInState]
  }
  schools.value = allSchools
  
  searchDto.value.totalEntities = allSchools.length
  searchDto.value.totalPages = Math.ceil(allSchools.length / searchDto.value.pageSize) ?? 0
}

const fetchRequestorDetails = async () => {
  if (!selectedSchool.value?.guid){
    // TODO: Handle Error
    return
  }
  const result = await schoolStore.schoolByRequestor(selectedSchool.value!.guid) 
  
  if (result.isSuccessful) {
    schoolDetails.value = result.content!.school
    if (result.content!.school.bankDetail){
      schoolBankDetails.value = result.content!.school.bankDetail!
    } else {
      schoolBankDetails.value = {
        name: '',
        branchCode: '',
        accountNumber: '',
        bankAccountType: BankAccountTypeEnum.Cheque
      }
    }
    userDto.value = result.content!.user as UserDto
    
    if (userDto.value.userContacts && userDto.value.userContacts.length !== 0){
      requestorNumber.value = userDto.value.userContacts.find(x => x.contact.contactTypeEnum === ContactTypeEnum.Mobile || x.contact.contactTypeEnum === ContactTypeEnum.Phone)!.contact.value
    }
    if (result.content!.requestorRoleEnum){
      role.value = result.content!.requestorRoleEnum.toString()
    }
    return
  }
}

watch(() => schoolDetails.value, (newValue) => {
  // School
  const nameError = schoolDetails.value!.name?.trim() === '' ? 'School Name is required' : undefined
  const emisError = schoolDetails.value!.emis?.trim() === '' ? 'School Emis is required' : undefined

  // Contact Person
  const contactPersonError = schoolDetails.value!.contactPersonName?.trim() === '' ? 'Contact Person is required' : undefined
  const contactPersonNumberError = schoolDetails.value!.contactPersonDetails?.trim() === '' ? 'Phone Number is required' : undefined

  // Address
  const streetError = schoolDetails.value!.address.street?.trim() === '' ? 'School Street Address is required' : undefined
  const townError = schoolDetails.value!.address.city?.trim() === '' ? 'School Town Address is required' : undefined
  const provinceError = schoolDetails.value!.address.province?.trim() === '' ? 'School Province Address is required' : undefined
  const postalCodeError = schoolDetails.value!.address.postalCode?.trim() === '' ? 'School Postal Code is required' : undefined
  
  hasSchoolErrors.value = ((nameError || emisError || contactPersonNumberError || contactPersonError || streetError || townError || provinceError || postalCodeError) ?? false) as boolean
  
  isReadyForApproval.value = !hasBankDetailsErrors.value && !hasSchoolErrors.value;
}, {deep: true, immediate: true})

watch(() => hasBankDetailsErrors.value, (newValue) => {
  isReadyForApproval.value = !newValue && !hasSchoolErrors.value;
}, {deep: true, immediate: true})

const updateSchoolDetails = async () => {
  if (!selectedSchool.value?.guid){
    // TODO: Handle error
    return
  } 

  const updatedSchoolDto = schoolDetails.value
  
  if (schoolBankDetails.value.bankAccountType){
    updatedSchoolDto!.bankDetail = schoolBankDetails.value
  }

  const updateSchoolDetailsResult = await schoolStore.updateSchoolDetails(selectedSchool.value.guid!, updatedSchoolDto);
    if (updateSchoolDetailsResult.isSuccessful) 
    {
      Toast.success("School changes successfully saved")
      location.reload()
    }
}

const closeAllKebabMenus = () => {
  const openMenus = schools.value!.filter(school => school.showKebabMenu)
  openMenus.forEach(school => school.showKebabMenu = false)
}

const handleClickOutside = (event: MouseEvent) => {
  // Cast the target of the event to an Element to access DOM properties
  const targetElement = event.target as Element;

  if(targetElement.id !== 'kebab'){
    closeAllKebabMenus();
  }
};
const toggleKebabMenu = (school: SchoolDto) => {
  closeAllKebabMenus()
  school.showKebabMenu = true
}

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
})

onMounted(async () => {
  document.addEventListener('click', handleClickOutside);
  states.value = Object.values(SchoolStateEnum).filter(state => state !== "Loaded")
  if (states){
    await fetchAllSchools(states.value)
  }
  
  userDto.value = {
    firstName: '',
    lastName: '',
    email: '',
  } as UserDto

  bus.on('toggle-approve-modal', toggleApproveModal)
  bus.on('approve-campaign', approveSchool)
  bus.on('toggle-decline-modal', toggleDeclineModal)
  bus.on('decline-campaign', declineSchool)
})

const filteredSchools = computed(() => {
  let filtered : SchoolDto[] = [];
  if(schools.value){
    filtered = schools.value
    if (currentFilter.value) {
      filtered = filtered.filter(school => school.entityState === currentFilter.value);
    }
    if (searchTerm.value) {
      filtered = filtered.filter(school => school!.name!.toLowerCase().includes(searchTerm.value.toLowerCase()));
      searchDto.value.pageNumber = 1;
    }
  }
  
  if (searchDto.value){
    searchDto.value.totalPages = Math.ceil(filtered.length / searchDto.value!.pageSize)
  }
  
  return filtered;
});

const approveSchool = async () => {
  // Save changes
  await updateSchoolDetails()
  
  if (!selectedSchool.value?.guid){
    // TODO: Handle error
    return
  }
  
  let approveSchoolResult = await schoolStore.updateState(selectedSchool.value!.guid, SchoolStateEnum.Approved)
  
  if (approveSchoolResult.isSuccessful) 
  {
    Toast.success("School successfully approved")
  }
  
  toggleApproveModal()
  location.reload()
}

const declineSchool = async () => {
  if (!selectedSchool.value?.guid){
    // TODO: Handle error
    return
  }
  
  let declineSchoolResult = await schoolStore.updateState(selectedSchool.value!.guid!, SchoolStateEnum.Rejected)
  if (declineSchoolResult.isSuccessful) 
  {
    Toast.success("School successfully declined")
  }
  toggleDeclineModal()
  location.reload()
}

// Pagination
watch(() => currentFilter.value, (newValue) => {
  if (searchDto.value){
    searchDto.value!.pageNumber = 1
  }
})

const totalPages = computed(() => {
  if (schools.value && schools.value?.length > 0){
    return filteredSchools.value ? Math.ceil(filteredSchools.value!.length / searchDto.value!.pageSize) : 0
  }
})

const paginatedSchools = computed(() => {
  let start = (searchDto.value.pageNumber - 1) * searchDto.value.pageSize
  let end = start + searchDto.value.pageSize
  return filteredSchools.value.slice(start, end)
})

const handlePageChange = async (newPage: number) => {
  if (searchDto.value?.totalPages && newPage <= searchDto.value.totalPages && newPage > 0){
    searchDto.value!.pageNumber = newPage
  }
}

const filterSchools = (status: string) => {
  currentFilter.value = status
  searchDto.value.pageNumber = 1
};

const toggleApproveModal = () => {
  showApproveModal.value = !showApproveModal.value
}

const toggleDeclineModal = () => {
  showDeclineModal.value = !showDeclineModal.value
}

const showSchoolDetailsPage = (school: SchoolDto) => {
  pageTitle.value = 'School Details'
  showSchoolDetails.value = true;
  showSearchField.value = false;
  selectedSchool.value = school;

  fetchRequestorDetails()
}

const goBackFromSchoolDetails = () => {
  pageTitle.value = 'School Management'
  showSchoolDetails.value = false;
  showSearchField.value = true;

  closeAllKebabMenus()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AdminSidebar, {
      showSearchField: _unref(showSearchField),
      pageTitle: _unref(pageTitle)
    }, null, 8, ["showSearchField", "pageTitle"]),
    _createElementVNode("div", _hoisted_1, [
      (!_unref(showSchoolDetails))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("form", _hoisted_5, [
                  _hoisted_6,
                  _hoisted_7,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchTerm) ? (searchTerm).value = $event : searchTerm = $event)),
                    id: "search-field",
                    class: "h-full w-80 border border-dark-blue rounded-md py-3 pl-8 pr-0 text-dark-blue placeholder:text-gray-400 sm:text-sm outline-none",
                    placeholder: "Search School Name..."
                  }, null, 512), [
                    [_vModelText, _unref(searchTerm)]
                  ])
                ])
              ]),
              _createVNode(SchoolStateFilterButtons, {
                onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_isRef(currentFilter) //@ts-ignore
 ? currentFilter.value = $event : currentFilter = $event)),
                "style-class": 'flex justify-end gap-x-4',
                "type-options": schoolStateOptions.value,
                "model-value": _unref(currentFilter)
              }, null, 8, ["type-options", "model-value"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("tbody", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedSchools.value, (school, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: school.guid
                    }, [
                      _createElementVNode("td", _hoisted_12, _toDisplayString(school.name), 1),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(school.address.city), 1),
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["px-2.5 py-1.5 rounded-md", _unref(getStatusClass)(school.entityState)])
                        }, _toDisplayString(school.entityState), 3)
                      ]),
                      _createElementVNode("td", _hoisted_15, [
                        _createElementVNode("a", {
                          href: `#/edit/${school.guid}`,
                          class: "relative inline-block"
                        }, [
                          _createElementVNode("img", {
                            src: "/img/Icons/kebab_menu.svg",
                            id: "kebab",
                            alt: "Menu",
                            onClick: ($event: any) => (toggleKebabMenu(school)),
                            class: "cursor-pointer"
                          }, null, 8, _hoisted_17),
                          _createElementVNode("span", _hoisted_18, ", " + _toDisplayString(school.name), 1),
                          (school.showKebabMenu)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (showSchoolDetailsPage(school)),
                                  class: "cursor-pointer px-3 py-2 hover:bg-[#DBEAFE]"
                                }, _hoisted_22, 8, _hoisted_20)
                              ]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_16)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(showSchoolDetails) && _unref(selectedSchool))
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("p", _hoisted_25, [
                _createTextVNode("Status: "),
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: _unref(getEntityStateColour)(_unref(selectedSchool).entityState ?? '') })
                }, _toDisplayString(_unref(selectedSchool) ? _unref(selectedSchool).entityState : 'Loading...'), 5)
              ]),
              _hoisted_26,
              _createElementVNode("div", {
                class: _normalizeClass(["flex justify-end gap-x-4", { 'invisible': !(_unref(selectedSchool) && _unref(selectedSchool).entityState === 'Requested') }])
              }, [
                _createVNode(Button, {
                  buttonText: "Approve",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => {_isRef(showApproveModal) //@ts-ignore
 ? showApproveModal.value = true : showApproveModal = true;}),
                  class: _normalizeClass([{'opacity-50 cursor-not-allowed': !isReadyForApproval.value}, "px-10 py-1.5 bg-green text-white rounded-md shadow-md"]),
                  disabled: !isReadyForApproval.value
                }, null, 8, ["class", "disabled"]),
                _createVNode(Button, {
                  buttonText: "Decline",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(showDeclineModal) //@ts-ignore
 ? showDeclineModal.value = true : showDeclineModal = true)),
                  class: "px-10 py-1.5 bg-orange-red text-white rounded-md shadow-md"
                })
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("form", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        (userDto.value)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userDto.value.firstName) = $event)),
                              disabled: "",
                              type: "text",
                              placeholder: "First Name",
                              class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none"
                            }, null, 512)), [
                              [_vModelText, userDto.value.firstName]
                            ])
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("div", _hoisted_36, [
                        (userDto.value)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userDto.value.lastName) = $event)),
                              disabled: "",
                              type: "text",
                              placeholder: "Last Name",
                              class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none"
                            }, null, 512)), [
                              [_vModelText, userDto.value.lastName]
                            ])
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("div", _hoisted_39, [
                        (userDto.value)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((userDto.value.email) = $event)),
                              disabled: "",
                              type: "email",
                              placeholder: "Email",
                              class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none"
                            }, null, 512)), [
                              [_vModelText, userDto.value.email]
                            ])
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("input", {
                          value: requestorNumber.value,
                          disabled: "",
                          type: "tel",
                          placeholder: "Phone Number",
                          class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none"
                        }, null, 8, _hoisted_43)
                      ])
                    ]),
                    _createVNode(Dropdown, {
                      class: "sm:col-span-3 pointer-events-none opacity-60",
                      label: "Requestor's Role",
                      placeholder: "Select Role",
                      options: _unref(requestorTypeOptions),
                      modelValue: _unref(role),
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(role) ? (role).value = $event : role = $event))
                    }, null, 8, ["options", "modelValue"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _createVNode(Button, {
                  buttonText: "Approved",
                  class: "px-10 py-1.5 bg-green text-white rounded-md shadow-md invisible",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (filterSchools('Approved')))
                }),
                _createVNode(Button, {
                  buttonText: "Decline",
                  class: "px-10 py-1.5 bg-orange-red text-white rounded-md shadow-md invisible",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (filterSchools('Rejected')))
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("form", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createElementVNode("div", _hoisted_54, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((schoolDetails.value.name) = $event)),
                          type: "text",
                          placeholder: "School Name",
                          class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none",
                          required: ""
                        }, null, 512), [
                          [_vModelText, schoolDetails.value.name]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("div", _hoisted_57, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((schoolDetails.value.emis) = $event)),
                          type: "text",
                          placeholder: "School EMIS Number",
                          class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none",
                          required: ""
                        }, null, 512), [
                          [_vModelText, schoolDetails.value.emis]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("div", _hoisted_60, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((schoolDetails.value.address.street) = $event)),
                          type: "text",
                          placeholder: "Street Address",
                          class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none"
                        }, null, 512), [
                          [_vModelText, schoolDetails.value.address.street]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _createElementVNode("div", _hoisted_63, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((schoolDetails.value.address.city) = $event)),
                          type: "text",
                          placeholder: "Town",
                          class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none",
                          required: ""
                        }, null, 512), [
                          [_vModelText, schoolDetails.value.address.city]
                        ])
                      ])
                    ]),
                    _createVNode(Dropdown, {
                      class: "sm:col-span-2",
                      label: "Province*",
                      placeholder: "Select Province",
                      options: _unref(provinceOptions),
                      modelValue: schoolDetails.value.address.province!,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((schoolDetails.value.address.province!) = $event))
                    }, null, 8, ["options", "modelValue"]),
                    _createElementVNode("div", _hoisted_64, [
                      _hoisted_65,
                      _createElementVNode("div", _hoisted_66, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((schoolDetails.value.address.postalCode) = $event)),
                          type: "text",
                          placeholder: "Postal Code",
                          class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none"
                        }, null, 512), [
                          [_vModelText, schoolDetails.value.address.postalCode]
                        ])
                      ])
                    ]),
                    _createVNode(Dropdown, {
                      class: "sm:col-span-full",
                      label: "Public or Private School",
                      placeholder: "Select Option",
                      options: _unref(schoolTypeOptions),
                      modelValue: schoolDetails.value.schoolType,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((schoolDetails.value.schoolType) = $event))
                    }, null, 8, ["options", "modelValue"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_67, [
              _hoisted_68,
              _hoisted_69,
              _createElementVNode("div", _hoisted_70, [
                _createVNode(Button, {
                  buttonText: "Approved",
                  class: "px-10 py-1.5 bg-green text-white rounded-md shadow-md invisible",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (filterSchools('Approved')))
                }),
                _createVNode(Button, {
                  buttonText: "Decline",
                  class: "px-10 py-1.5 bg-orange-red text-white rounded-md shadow-md invisible",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (filterSchools('Rejected')))
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("form", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _hoisted_76,
                      _createElementVNode("div", _hoisted_77, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((schoolDetails.value.contactPersonName) = $event)),
                          type: "text",
                          placeholder: "Contact Person",
                          class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none",
                          required: ""
                        }, null, 512), [
                          [_vModelText, schoolDetails.value.contactPersonName]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _hoisted_79,
                      _createElementVNode("div", _hoisted_80, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((schoolDetails.value.contactPersonDetails) = $event)),
                          type: "text",
                          placeholder: "Phone Number",
                          class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none",
                          required: ""
                        }, null, 512), [
                          [_vModelText, schoolDetails.value.contactPersonDetails]
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _hoisted_83,
              _createElementVNode("div", _hoisted_84, [
                _createVNode(Button, {
                  buttonText: "Approved",
                  class: "px-10 py-1.5 bg-green text-white rounded-md shadow-md invisible",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (filterSchools('Approved')))
                }),
                _createVNode(Button, {
                  buttonText: "Decline",
                  class: "px-10 py-1.5 bg-orange-red text-white rounded-md shadow-md invisible",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (filterSchools('Rejected')))
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _createVNode(BankDetailsForm, {
                onUpdate: _cache[23] || (_cache[23] = ($event: any) => (schoolBankDetails.value = $event)),
                onHasError: _cache[24] || (_cache[24] = ($event: any) => (hasBankDetailsErrors.value = $event)),
                "bank-details": schoolBankDetails.value,
                "show-errors": showFormErrors.value
              }, null, 8, ["bank-details", "show-errors"])
            ]),
            _createElementVNode("div", _hoisted_86, [
              _hoisted_87,
              _hoisted_88,
              _createElementVNode("div", _hoisted_89, [
                _createVNode(Button, {
                  buttonText: "Approved",
                  class: "px-10 py-1.5 bg-green text-white rounded-md shadow-md invisible",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (filterSchools('Approved')))
                }),
                _createVNode(Button, {
                  buttonText: "Decline",
                  class: "px-10 py-1.5 bg-orange-red text-white rounded-md shadow-md invisible",
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (filterSchools('Rejected')))
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("form", _hoisted_91, [
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("div", _hoisted_94, [
                      _hoisted_95,
                      _createElementVNode("div", _hoisted_96, [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((schoolDetails.value.notes) = $event)),
                          rows: "4",
                          type: "text",
                          class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none",
                          required: ""
                        }, null, 512), [
                          [_vModelText, schoolDetails.value.notes]
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_97, [
              _createVNode(Button, {
                buttonText: "Back",
                onClick: goBackFromSchoolDetails,
                class: "w-72 py-1.5 border border-dark-blue rounded-md shadow-md"
              }),
              _createVNode(Button, {
                buttonText: "Save Changes",
                onClick: updateSchoolDetails,
                class: "w-72 py-1.5 bg-green text-white rounded-md shadow-md"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(showApproveModal))
        ? (_openBlock(), _createBlock(CampaignApproveModal, {
            key: 2,
            name: _unref(selectedSchool) ? _unref(selectedSchool).name : '',
            onToggleApproveModal: _cache[28] || (_cache[28] = ($event: any) => (_isRef(showApproveModal) //@ts-ignore
 ? showApproveModal.value = false : showApproveModal = false)),
            onApproveCampaign: approveSchool
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      (_unref(showDeclineModal))
        ? (_openBlock(), _createBlock(CampaignDeclineModal, {
            key: 3,
            name: _unref(selectedSchool) ? _unref(selectedSchool).name : '',
            onToggleDeclineModal: _cache[29] || (_cache[29] = ($event: any) => (_isRef(showDeclineModal) //@ts-ignore
 ? showDeclineModal.value = false : showDeclineModal = false)),
            onDeclineCampaign: declineSchool
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      (!_unref(showSchoolDetails) && filteredSchools.value.length === 0)
        ? (_openBlock(), _createBlock(NotFound, {
            key: 4,
            notFoundText: "School Does Not Exist"
          }))
        : _createCommentVNode("", true),
      (!_unref(showSchoolDetails) && totalPages.value && searchDto.value.totalEntities)
        ? (_openBlock(), _createBlock(PaginationV2, {
            key: 5,
            onChange: handlePageChange,
            "search-dto": searchDto.value
          }, null, 8, ["search-dto"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})